import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { CategoryResponseDto } from "../../shared/dtos/category/CategoryResponseDto";

interface CategoryCardProps {
  category: CategoryResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({
  category,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" noWrap sx={{ fontWeight: "bold" }}>
              {category.name}
            </Typography>
          </Box>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit Category">
                <IconButton size="small" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete Category">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
          {category.description || "No description provided."}
        </Typography>
      </Box>
    </StyledCard>
  );
};

export default CategoryCard;
